/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

export const AudienceSignalColumn = ({ i18n }) => ({
  key: 'AudienceSignal',
  name: i18n.getString(_TL_('Audience signal')),
  fieldName: 'AudienceGroup',
  className: 'column-audience-signal',
  headerClassName: 'header-audience-signal',
  minWidth: 150,
  maxWidth: 300,
  sortable: false,
  isMultiline: true,
  isResizable: true,
  onRender: ({ AudienceGroup }) => (
    <span>
      {AudienceGroup && AudienceGroup.Name}
      {!AudienceGroup && i18n.getString(_TL_('Automatic (None provided)'))}
    </span>
  ),
});
